import store_rendez_vous from '@/store/mods/clinique/rendez_vous'
import { jour_local, jour_rdv, jour_lisible, date_rdv_lisible, message_erreur } from '@/utils/rendez-vous'

// RDV-006 : le médecin a donné un rendez-vous sans heure (« heure à fixer ») ; l'Accueil ou la Caisse, qui connaît le
// planning des médecins, fixe l'heure. Le jour reste celui du médecin (lecture seule) ; seule l'heure est saisie.
// La Clinique refuse une heure passée et signale, sans bloquer, un autre rendez-vous du médecin à la même heure.
export default {
    name: 'fixer-heure-rendez-vous',
    components: {},
    props: {
        rendez_vous: { type: Object, default: null },   // ligne de l'agenda, des rappels ou de la fiche patient
        toggler: { type: Number, default: 0 }
    },
    data() {
        return {
            modal: false, heure: '', is_saving: false, erreur_form: '', resultat: null, a_actualiser: false, detruit: false
        }
    },

    watch: {
        toggler() {
            this.ouvrir()
        }
    },

    computed: {
        jour() {
            return jour_rdv(this.rendez_vous)
        },

        jour_texte() {
            return this.jour ? jour_lisible(this.jour) : 'Jour non renseigné'
        },

        conflits() {
            return this.resultat && Array.isArray(this.resultat.conflits) ? this.resultat.conflits : []
        },

        rendez_vous_fixe() {
            return this.resultat && this.resultat.rendez_vous ? this.resultat.rendez_vous : null
        }
    },

    beforeDestroy() {
        this.detruit = true
    },

    methods: {
        ouvrir() {
            if (this.is_saving) return
            this.heure = ''
            this.erreur_form = ''
            this.resultat = null
            this.a_actualiser = false
            this.modal = true
        },

        // Heure locale du poste « AAAA-MM-JJ HH:MM » : refuse une heure déjà passée avant l'appel (la Clinique vérifie aussi)
        maintenant_local() {
            const d = new Date(), deux = n => (n < 10 ? '0' : '') + n
            return jour_local(d) + ' ' + deux(d.getHours()) + ':' + deux(d.getMinutes())
        },

        heure_saisie() {
            return String(this.heure || '').substr(0, 5)
        },

        valider() {
            if (!this.rendez_vous || !this.rendez_vous.rendez_vous_id) return 'Rendez-vous introuvable.'
            // Jour passé (liste restée ouverte après minuit) : aucune heure ne sera acceptée par la Clinique
            if (this.jour && this.jour < jour_local(new Date())) return 'Ce jour est passé : marquez le rendez-vous honoré ou absent, ou reprogrammez-le.'
            const heure = this.heure_saisie()
            if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(heure)) return 'Indiquez l\'heure du rendez-vous.'
            if (this.jour && this.jour + ' ' + heure <= this.maintenant_local()) return 'Cette heure est déjà passée.'
            return ''
        },

        enregistrer() {
            if (this.is_saving || this.resultat) return Promise.resolve()
            const erreur = this.valider()
            if (erreur) {
                this.erreur_form = erreur
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_form = ''
            return store_rendez_vous.fixerHeureRendezVous({ rendez_vous_id: Number(this.rendez_vous.rendez_vous_id), heure: this.heure_saisie() }).then((response) => {
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Heure refusée')
                this.is_saving = false
                this.resultat = response
                this.$emit('emitHeureFixee', response.rendez_vous || null, response)
            }).catch((error) => {
                if (this.detruit) return
                this.is_saving = false
                const statut = error && error.response ? Number(error.response.status) : 0
                // Rendez-vous introuvable ou heure déjà fixée ailleurs : la liste du parent est à recharger à la fermeture
                if (statut === 404 || statut === 409) this.a_actualiser = true
                this.erreur_form = message_erreur(error, 'L\'heure n\'a pas été enregistrée. Réessayez.')
            })
        },

        fermer() {
            this.modal = false
        },

        apres_fermeture() {
            const actualiser = this.a_actualiser && !this.resultat
            this.a_actualiser = false
            if (actualiser) this.$emit('emitActualiser')
        },

        date_rdv(ligne) {
            return date_rdv_lisible(ligne)
        }
    }
}
